/**
 * The user org router works for the organization management for the app.
 * The user org router use the root one as the module scope.
 * It use the tbs.core.AbstractScene as the plugin to improve the development
 * base on the vue framework. It treats the following view as the scene
 * instance.
 *
 * The TBS Scene plugin introduces the properties, mediator, convertor, 
 * translator properties for the built-in meta object.
 *
 * The properties property stands for the context object with the scene view.
 * It contains the title, route, router, bridge* and so on which is used into
 * the mediator.
 *
 * The mediator property stands for the business controller with the scene
 * view. We treat the view as the special component to maintain the whole
 * component-based development pattern. Therefore, it separate the business
 * logic from view to mediator.
 *
 * The convertor property stands for the data convertor between view object
 * and entity object. We treat the data via requesting the service API as the 
 * entity object which is the persistence data and also treat the data via 
 * rendering the UI component as the view object.
 *
 * The translator property stands for the dictionary feature and also acts as the
 * simple version for the i18n module.
 */
const UserOrgRouter = {
    path: '/user-org',
    name: 'UserOrg',
    component: () => import('@/views/user-org/UserOrgScene'),
    children: [
        {
            path: 'organization/manage/:id',
            name: 'UserOrgManageOrganization',
            meta: {
                properties: {
                    title: '机构管理',
                    login: 'app'
                },
                mediator: () => import('@/fcl/tbs/controller/OrganizationMediator'), 
                convertor: () => import('@/fcl/tbs/model/vo/OrganizationManager'),
                translator:() => import('@/fcl/tbs/model/to/Organization')
            },
            component: () => import('@/views/user-org/OrganizationManage')
        },
        {
            path: 'organization/list',
            name: 'UserOrgListOrganization',
            meta: {
                properties: {
                    title: '机构列表'
                },
                mediator: () => import('@/fcl/tbs/controller/OrganizationMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Organization'),
                translator:() => import('@/fcl/tbs/model/to/Organization')
            },
            component: () => import('@/views/user-org/OrganizationList')
        },
        {
            path: 'organization/create',
            name: 'UserOrgCreateOrganization',
            meta: {
                properties: {
                    title: '新建机构'
                },
                mediator: () => import('@/fcl/tbs/controller/OrganizationMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Organization'),
                translator:() => import('@/fcl/tbs/model/to/Organization')
            },
            component: () => import('@/views/user-org/OrganizationEdit')
        },
        {
            path: 'organization/detail/:id',
            name: 'UserOrgDetailOrganization',
            meta: {
                properties: {
                    title: '机构详情'
                },
                mediator: () => import('@/fcl/tbs/controller/OrganizationMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Organization'),
                translator:() => import('@/fcl/tbs/model/to/Organization')
            },
            component: () => import('@/views/user-org/OrganizationDetail')
        },
        {
            path: 'organization/edit/:id',
            name: 'UserOrgEditOrganization',
            meta: {
                properties: {
                    title: '编辑机构'
                },
                mediator: () => import('@/fcl/tbs/controller/OrganizationMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Organization'),
                translator:() => import('@/fcl/tbs/model/to/Organization')
            },
            component: () => import('@/views/user-org/OrganizationEdit')
        },
        {
            path: 'referee/list',
            name: 'UserOrgListReferee',
            meta: {
                properties: {
                    title: '裁判库'
                },
                mediator: () => import('@/fcl/tbs/controller/RefereeMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Referee'),
                translator:() => import('@/fcl/tbs/model/to/Referee')
            },
            component: () => import('@/views/user-org/RefereeList')
        },
        {
            path: 'referee/create',
            name: 'UserOrgCreateReferee',
            meta: {
                properties: {
                    title: '新建裁判员'
                },
                mediator: () => import('@/fcl/tbs/controller/RefereeMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Referee'),
                translator:() => import('@/fcl/tbs/model/to/Referee')
            },
            component: () => import('@/views/user-org/RefereeEdit')
        },
        {
            path: 'referee/detail/:id',
            name: 'UserOrgDetailReferee',
            meta: {
                properties: {
                    title: '裁判员详情'
                },
                mediator: () => import('@/fcl/tbs/controller/RefereeMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Referee'),
                translator:() => import('@/fcl/tbs/model/to/Referee')
            },
            component: () => import('@/views/user-org/RefereeDetail')
        },
        {
            path: 'referee/edit/:id',
            name: 'UserOrgEditReferee',
            meta: {
                properties: {
                    title: '编辑裁判员'
                },
                mediator: () => import('@/fcl/tbs/controller/RefereeMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Referee'),
                translator:() => import('@/fcl/tbs/model/to/Referee')
            },
            component: () => import('@/views/user-org/RefereeEdit')
        },
        {
            path: 'referee/invite',
            name: 'UserOrgInviteReferee',
            meta: {
                properties: {
                    title: '裁判员邀请'
                },
                mediator: () => import('@/fcl/tbs/controller/RefereeInviteMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Referee'),
                translator:() => import('@/fcl/tbs/model/to/Referee')
            },
            component: () => import('@/fcl/components/user/MemberInvite')
        },
        {
            path: 'referee/accept',
            name: 'UserOrgAcceptReferee',
            meta: {
                properties: {
                    title: ''
                },
                mediator: () => import('@/fcl/tbs/controller/RefereeInviteMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Referee'),
                translator:() => import('@/fcl/tbs/model/to/Referee')
            },
            component: () => import('@/fcl/components/user/MemberAccept')
        },
        {
            path: 'staff/list',
            name: 'UserOrgListStaff',
            meta: {
                properties: {
                    title: '工作人员'
                },
                mediator: () => import('@/fcl/tbs/controller/StaffMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Staff'),
                translator:() => import('@/fcl/tbs/model/to/Staff')
            },
            component: () => import('@/views/user-org/StaffList')
        },
        {
            path: 'staff/create',
            name: 'UserOrgCreateStaff',
            meta: {
                properties: {
                    title: '新建工作人员'
                },
                mediator: () => import('@/fcl/tbs/controller/StaffMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Staff'),
                translator:() => import('@/fcl/tbs/model/to/Staff')
            },
            component: () => import('@/views/user-org/StaffEdit')
        },
        {
            path: 'staff/detail/:id',
            name: 'UserOrgDetailStaff',
            meta: {
                properties: {
                    title: '工作人员详情'
                },
                mediator: () => import('@/fcl/tbs/controller/StaffMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Staff'),
                translator:() => import('@/fcl/tbs/model/to/Staff')
            },
            component: () => import('@/views/user-org/StaffDetail')
        },
        {
            path: 'staff/edit/:id',
            name: 'UserOrgEditStaff',
            meta: {
                properties: {
                    title: '编辑工作人员'
                },
                mediator: () => import('@/fcl/tbs/controller/StaffMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Staff'),
                translator:() => import('@/fcl/tbs/model/to/Staff')
            },
            component: () => import('@/views/user-org/StaffEdit')
        },
        {
            path: 'staff/invite',
            name: 'UserOrgInviteStaff',
            meta: {
                properties: {
                    title: '工作人员邀请'
                },
                mediator: () => import('@/fcl/tbs/controller/StaffInviteMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Staff'),
                translator:() => import('@/fcl/tbs/model/to/Staff')
            },
            component: () => import('@/fcl/components/user/MemberInvite')
        },
        {
            path: 'staff/accept',
            name: 'UserOrgAcceptStaff',
            meta: {
                properties: {
                    title: ''
                },
                mediator: () => import('@/fcl/tbs/controller/StaffInviteMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Staff'),
                translator:() => import('@/fcl/tbs/model/to/Staff')
            },
            component: () => import('@/fcl/components/user/MemberAccept')
        },
        {
            path: 'executor/invite',
            name: 'UserOrgInviteExecutor',
            meta: {
                properties: {
                    title: '赛事执行邀请'
                },
                mediator: () => import('@/fcl/tbs/controller/ExecutorInviteMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Executor'),
                translator:() => import('@/fcl/tbs/model/to/Executor')
            },
            component: () => import('@/fcl/components/user/MemberInvite')
        },
        {
            path: 'executor/accept',
            name: 'UserOrgAcceptExecutor',
            meta: {
                properties: {
                    title: ''
                },
                mediator: () => import('@/fcl/tbs/controller/ExecutorInviteMediator'),
                convertor: () => import('@/fcl/tbs/model/vo/Executor'),
                translator:() => import('@/fcl/tbs/model/to/Executor')
            },
            component: () => import('@/fcl/components/user/MemberAccept')
        },
    ]
}

export default UserOrgRouter